import { Component, input } from '@angular/core';

@Component({
  selector: 'ui-card',
  standalone: true,
  template: `
    <div
      class="bg-[var(--bg-surface)] border border-[var(--border)] rounded-[var(--r-md)] shadow-[var(--shadow-card)] p-5 transition-all duration-200 hover:-translate-y-[1px] hover:shadow-[0_8px_24px_rgba(15,23,42,0.08)]"
    >
      <div class="text-[15px] font-semibold tracking-tight text-[var(--text)] mb-4">
        {{ title() }}
      </div>
      <ng-content></ng-content>
    </div>
  `,
  host: {
    class: 'block',
  },
})
export class UiCardComponent {
  title = input.required<string>();
}
